import React from "react";
import { suaraIndonesia } from "@/lib/layarProduksi";

// Owner 2026-10-16 (requirement 61): test page for the shop TV (Xiaomi TV A32) — no data,
// no login. Shows what the TV browser offers (viewport, pixel ratio, voices) and tests the
// tone, the Indonesian voice, an audio file, and 5 minutes of announcements without touching
// the remote. The results decide the sound option before the TV is used ("perlu uji di toko").
const SPS = typeof window !== "undefined" ? window.speechSynthesis : null;

function wavNada(detik = 1, f = 660) {  // a short WAV built in the browser (no file on the server)
  const rate = 16000; const n = rate * detik; const buf = new ArrayBuffer(44 + n * 2); const v = new DataView(buf);
  const tulis = (o, s) => [...s].forEach((c, i) => v.setUint8(o + i, c.charCodeAt(0)));
  tulis(0, "RIFF"); v.setUint32(4, 36 + n * 2, true); tulis(8, "WAVE"); tulis(12, "fmt "); v.setUint32(16, 16, true);
  v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, rate, true); v.setUint32(28, rate * 2, true);
  v.setUint16(32, 2, true); v.setUint16(34, 16, true); tulis(36, "data"); v.setUint32(40, n * 2, true);
  for (let i = 0; i < n; i += 1) v.setInt16(44 + i * 2, Math.sin((2 * Math.PI * f * i) / rate) * 12000 * Math.min(1, (n - i) / 2000), true);
  return URL.createObjectURL(new Blob([buf], { type: "audio/wav" }));
}

export default function LayarUji() {
  const [voices, setVoices] = React.useState([]);
  const [log, setLog] = React.useState([]);
  const ctx = React.useRef(null);
  const catat = (t) => setLog((l) => [`${new Date().toLocaleTimeString("id-ID")} — ${t}`, ...l].slice(0, 40));
  React.useEffect(() => {
    if (!SPS) return undefined;
    const f = () => setVoices(SPS.getVoices());
    f(); SPS.addEventListener?.("voiceschanged", f);
    return () => SPS.removeEventListener?.("voiceschanged", f);
  }, []);
  const id = suaraIndonesia(voices);

  const nada = () => {
    try {
      const C = window.AudioContext || window.webkitAudioContext;
      ctx.current = ctx.current || new C(); ctx.current.resume();
      const o = ctx.current.createOscillator(); o.frequency.value = 880; o.connect(ctx.current.destination);
      o.start(); o.stop(ctx.current.currentTime + 0.4); catat("Nada: diputar");
    } catch (e) { catat(`Nada: GAGAL (${e.message})`); }
  };
  const bicara = (teks) => new Promise((res) => {
    if (!SPS) { catat("Suara: browser tidak punya speechSynthesis"); res(false); return; }
    const u = new SpeechSynthesisUtterance(teks); u.lang = "id-ID"; if (id) u.voice = id;
    let beres = false;
    const akhir = (ok, info) => { if (!beres) { beres = true; catat(`Suara: ${ok ? "selesai" : "GAGAL"} ${info || ""}`); res(ok); } };
    u.onend = () => akhir(true); u.onerror = (e) => akhir(false, e.error);
    setTimeout(() => akhir(false, "(tidak ada tanda selesai dalam 15 detik)"), 15000);
    SPS.speak(u);
  });
  const audioFile = async () => {
    try { await new Audio(wavNada()).play(); catat("File audio: diputar"); } catch (e) { catat(`File audio: GAGAL (${e.name})`); }
  };
  const otomatis = () => {
    catat("Uji otomatis 5 menit dimulai — jangan sentuh remote");
    for (let i = 1; i <= 5; i += 1) {
      setTimeout(async () => { nada(); await bicara(`Uji otomatis ke ${i}. SPK baru, nomor empat lima dua.`); }, i * 60000);
    }
  };

  const baris = (k, v) => <tr><td className="pr-4 align-top text-slate-500">{k}</td><td className="break-all font-mono">{v}</td></tr>;
  return (
    <div data-testid="tv-uji" className="min-h-screen bg-white p-6 text-[20px] text-slate-900">
      <h1 className="font-judul text-4xl uppercase text-soq-biru-tua">Uji layar produksi</h1>
      <table className="my-4"><tbody>
        {baris("Browser", navigator.userAgent)}
        {baris("Ukuran layar CSS", `${window.innerWidth} × ${window.innerHeight}`)}
        {baris("devicePixelRatio", window.devicePixelRatio)}
        {baris("speechSynthesis", SPS ? "ada" : "TIDAK ADA")}
        {baris("Jumlah suara", voices.length)}
        {baris("Suara Indonesia", id ? `${id.name} (${id.lang}${id.localService ? ", lokal" : ", internet"})` : "TIDAK ADA")}
      </tbody></table>
      <div className="flex flex-wrap gap-3">
        <button data-testid="uji-nada" autoFocus onClick={nada} className="rounded-xl bg-soq-oranye px-5 py-3 font-bold text-soq-biru-tua">Tes nada</button>
        <button data-testid="uji-suara" onClick={() => bicara("Tes suara Indonesia. SPK baru, nomor empat lima dua, customer Budi.")} className="rounded-xl bg-soq-oranye px-5 py-3 font-bold text-soq-biru-tua">Tes suara Indonesia</button>
        <button data-testid="uji-audio" onClick={audioFile} className="rounded-xl bg-soq-oranye px-5 py-3 font-bold text-soq-biru-tua">Tes file audio</button>
        <button data-testid="uji-otomatis" onClick={otomatis} className="rounded-xl bg-soq-biru px-5 py-3 font-bold text-white">Uji otomatis 5 menit</button>
      </div>
      <details className="mt-4"><summary className="cursor-pointer text-slate-500">Semua suara ({voices.length})</summary>
        <ul className="font-mono text-[15px]">{voices.map((v) => <li key={`${v.name}${v.lang}`}>{v.lang} — {v.name}{v.localService ? " (lokal)" : ""}</li>)}</ul></details>
      <h2 className="mt-4 font-bold">Catatan uji</h2>
      <ul data-testid="uji-log" className="font-mono text-[16px]">{log.map((l) => <li key={l}>{l}</li>)}</ul>
    </div>
  );
}
